import ReactEcharts from 'echarts-for-react';
import { translateBlockValue } from 'i18n';
import type { DistributionBucket } from 'modules/datacatalog/types';
import { useTranslation } from 'react-i18next';

type Props = {
    buckets: DistributionBucket[];
};

const OTHERS_LABEL = '__others__';

const FieldDistributionChart = ({ buckets }: Props) => {
    const { t } = useTranslation();

    const data = buckets.map((bucket) => ({
        name:
            bucket.value === OTHERS_LABEL
                ? t('dataCatalog.others')
                : translateBlockValue(bucket.value.toUpperCase()),
        value: bucket.count,
    }));

    const option = {
        tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)',
        },
        legend: {
            orient: 'vertical',
            right: 0,
            top: 'middle',
        },
        series: [
            {
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: true,
                label: { show: false },
                labelLine: { show: false },
                data,
            },
        ],
    };

    return (
        <ReactEcharts option={option} style={{ height: 220, width: '100%' }} />
    );
};

export default FieldDistributionChart;
